import React from 'react'
import { Link } from 'react-router-dom'

import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { US } from 'country-flag-icons/react/3x2'
const California_classes = () => {

const slideLeft =() => {
    var slider = document.getElementsById('slider')
    slider.scrollLeft = slider.scrollLeft - 500;
}

const slideRight =() => {
    var slider = document.getElementsById('slider')
    slider.scrollLeft = slider.scrollLeft + 500;
}
    return (
        <div className=""> 
        
        <div  className='fixed top-23 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-blue-400 items-center'>      
        <MdChevronLeft onClick={slideLeft} size={40} />
        <Link to="/learning/california/independentlearning_k13" className=' text-white text-sm flex'>Independent Learning</Link>
        <Link to="/learning/california/prekindergartengrade_k0" className='text-white text-sm flex'>Pre-Kindergarten</Link>
        <Link to="/learning/california/kindergartengrade_k" className=' text-white text-sm flex'>Kindergarten</Link>
        <Link to="/learning/california/firstgrade_k1" className=' text-white text-sm flex'>First Grade</Link>
        <Link to="/learning/california/secondgrade_k2" className=' text-white text-sm flex'>Second Grade</Link>
        <Link to="/learning/california/thirdgrade_k3" className=' text-white text-sm flex'>Third Grade</Link>
        <Link to="/learning/california/fourthgrade_k4" className=' text-white text-sm flex'>Fourth Grade</Link>
        <Link to="/learning/california/fifthgrade_k5" className=' text-white text-sm flex'>Fifth Grade</Link>
        <Link to="/learning/california/sixthgrade_k6" className=' text-white text-sm flex'>Sixth Grade</Link>
        <Link to="/learning/california/seventhgrade_k7" className=' text-white text-sm flex'>Seventh Grade</Link>
        <Link to="/learning/california/eighthgrade_k8" className=' text-white text-sm flex'>Eighth Grade</Link>
        <Link to="/learning/california/ninethgrade_k9" className=' text-white text-sm flex'>Nineth Grade</Link>
        <Link to="/learning/california/tenthgrade_k10" className=' text-white text-sm flex'>Tenth Grade</Link>
        <Link to="/learning/california/eleventhgrade_k11" className=' text-white text-sm flex'>Eleventh Grade</Link>
        <Link to="/learning/california/twelvethgrade_k12" className=' text-white text-sm flex'>Twelfth Grade</Link>
        
            
        
        <MdChevronRight onClick={slideRight} size={40} />
        
        </div>  
               
        </div>
      
    )
}

export default California_classes;